import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import ServiceItemListViewModel, {
  ServiceItem,
} from './ServiceItemListViewModel'
import styles from './ServiceItemListDialog.sass'

interface ServiceItemListDialogProps {
  vm: ServiceItemListViewModel
}

export default observer(function ServiceItemListDialog({
  vm,
}: ServiceItemListDialogProps) {
  const serviceItems = vm.serviceItems

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader
        bordered
        withCloseButton
        subheader={
          <div className={styles.serviceItemListHeader}>
            <span className={styles.serviceItemListName}>Name</span>
            <span className={styles.serviceItemListQuantity}>Quantity</span>
          </div>
        }
      >
        <ModalSheetTitle>
          Service items
          <span className={styles.titleSubtext}>
            {` (${serviceItems.length})`}
          </span>
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        {serviceItems.map((item, index) => (
          <ServiceItem key={index} item={item} />
        ))}
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface ServiceItemProps {
  item: ServiceItem
}

const ServiceItem = ({ item }: ServiceItemProps) => (
  <div className={styles.serviceItem}>
    <span className={styles.serviceItemName}>{item.name}</span>
    <span className={styles.serviceItemQuantity}>{item.quantity}</span>
  </div>
)
